
const digest = 'f05eb3be67eb885b92d99eed27439e28289aef98508c5f321cca913ca32aeac4';
const classes = {"wrapper":"_wrapper_1su6c_1","buttonsWrapper":"_buttonsWrapper_1su6c_6","button":"_button_1su6c_6","codeWrapper":"_codeWrapper_1su6c_16","header":"_header_1su6c_19","content":"_content_1su6c_27"};
const css = `._wrapper_1su6c_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1su6c_1 ._buttonsWrapper_1su6c_6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
}
._wrapper_1su6c_1 ._buttonsWrapper_1su6c_6 ._button_1su6c_6 {
  width: fit-content;
}
._wrapper_1su6c_1 ._codeWrapper_1su6c_16 {
  border: 1px solid #eaedf3;
}
._wrapper_1su6c_1 ._codeWrapper_1su6c_16 ._header_1su6c_19 {
  font-size: 14px;
  color: #3e3f42;
  font-weight: 400;
  padding: 17px 24px;
  background-color: #fff;
  border-bottom: 1px solid #eaedf3;
}
._wrapper_1su6c_1 ._codeWrapper_1su6c_16 ._content_1su6c_27 {
  background-color: #e7f5fb;
  width: 100%;
  padding: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  